export default `/* Ids Modal Component */
:host {
  display: block;
  position: fixed;
  visibility: visible;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

:host(:not([visible])) {
  pointer-events: none;
  visibility: hidden;
}

.ids-modal {
  display: block;
  pointer-events: none;
}
.ids-modal[visible] {
  pointer-events: auto;
}
.ids-modal.fullsize {
  height: 100%;
}
.ids-modal.fullsize .ids-modal-container {
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
}
.ids-modal.fullsize .ids-modal-header + .ids-modal-content {
  overflow-y: auto;
}
.ids-modal:not(.scrollable) .has-scrollbar {
  overflow: hidden;
  padding: 0;
}
.ids-modal.scrollable .has-scrollbar {
  overflow: auto;
}
.ids-modal:not(.fullsize)::part(popup) {
  max-height: calc(100% - 32px);
}

.ids-modal-header {
  padding: var(--ids-modal-header-padding);
}

.ids-modal-content {
  padding: var(--ids-modal-content-padding);
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
}

.ids-modal-header + .ids-modal-content {
  padding-block-start: 0;
}

.ids-modal-header,
.ids-modal-footer {
  align-items: center;
  display: flex;
}

.ids-modal-footer {
  margin: var(--ids-modal-footer-margin);
  border-top: 1px solid var(--ids-modal-footer-color-border);
}
.ids-modal-footer[hidden] {
  border-top: none;
}

.ids-modal-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  max-height: calc(100vh - 64px);
}

::slotted([slot=buttons]) {
  flex-grow: 1;
  display: flex;
}

.modal-control-close {
  position: absolute;
  top: var(--ids-space-2xs);
  right: var(--ids-space-2xs);
}
.modal-control-close[dir=rtl] {
  left: var(--ids-space-2xs);
  right: unset;
}

::slotted([slot=buttons]:not(:first-of-type)) {
  border-inline-start: 1px solid var(--ids-modal-footer-color-border);
}

.ids-modal-button:not(.ids-modal-icon-button):not(:first-of-type) {
  border-left: 1px solid var(--ids-modal-footer-color-border);
}

::slotted([slot=title]) {
  overflow-wrap: var(--ids-message-overflow-wrap, normal);
}

@media screen and (min-width: 767px) {
  ::slotted([slot=title]) {
    font-size: var(--ids-font-size-lg);
  }
}
:host {
  display: block;
  line-height: normal;
}

:host([hidden]) {
  display: none;
}

/* Ensure popup part styles are applied in all browsers */
::part(popup) {
  width: calc(100% - var(--ids-space-lg));
  max-width: 400px;
  z-index: var(--ids-z-index-message);
}

.ids-message-status {
  padding-inline-end: 8px;
  color: var(--ids-message-color-text);
}
.ids-message-status.error {
  color: var(--ids-message-color-icon-error);
}
.ids-message-status.warning {
  color: var(--ids-message-color-icon-warning);
}
.ids-message-status.success {
  color: var(--ids-message-color-icon-success);
}
.ids-message-status.info {
  color: var(--ids-message-color-icon-info);
}
.ids-message-status.question {
  color: var(--ids-message-color-icon-question);
}

.ids-message-content {
  max-width: 400px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
